module.exports = __webpack_public_path__ + "static/img/study_report.ac1a2eee.png";